import React from 'react'
import { Helmet } from 'react-helmet-async'
import type { Metadata } from 'next'
import ServicePageTemplate, { ServicePageConfig } from '@/components/templates/ServicePageTemplate'

export const metadata: Metadata = {
  title: 'Art Escrow & Consulting | Member Services | FGA Prestige',
  description: 'Secure art transactions and expert consulting. Professional escrow services for fine art acquisitions, valuations, and secure transactions at FGA Prestige.',
  openGraph: {
    title: 'Art Escrow & Consulting | Member Services | FGA Prestige',
    description: 'Secure art transactions and expert consulting. Professional escrow services for fine art acquisitions, valuations, and secure transactions at FGA Prestige.',
    url: 'https://fgaprestige.com/member-services/art-escrow-consulting',
    images: [
      {
        url: '/Member Services/Art Escrow & Consulting/hero.png',
        width: 1200,
        height: 630,
        alt: 'FGA Prestige Art Escrow & Consulting Services',
      },
    ],
  },
}

const artEscrowConfig: ServicePageConfig = {
  title: 'Art Escrow & Consulting - FGA Prestige',
  description: 'Expert art acquisition, authentication, and escrow services.',
  slug: 'art-escrow-consulting',
  heroImage: '/Member Services/Art Escrow & Consulting/hero.png',
  serviceName: 'ART ESCROW & CONSULTING',
  whySectionA: {
    title: 'Where Passion Meets Portfolio',
    content: 'We believe art is more than decoration—it’s a strategic asset, a legacy in the making. Our Art Consultancy is your gateway to building a collection that not only inspires, but also elevates your wealth planning to an art form of its own.',
    image: '/Member Services/Art Escrow & Consulting/body/1.png',
    imageAlt: 'Art Consulting Services'
  },
  whySectionC: {
    title: 'An Epicurean’s Dream',
    content: 'Imagine receiving private invitations to exclusive auctions, or gliding past the crowds for VIP access at Art Basel and the world’s most coveted fairs. With us, these aren’t just perks—they’re part of your story as a collector.',
    image: '/Member Services/Art Escrow & Consulting/body/2.png',
    imageAlt: 'Exclusive Art Access'
  },
  whySectionB: {
    title: 'Your Personal Art Ally',
    benefits: [
      {
        title: '',
        description: 'Every collector’s journey is unique. That’s why you’re paired with a dedicated art consultant who understands your vision, your ambitions, and the nuances of both the market and the masterpieces. Together, you’ll navigate the art world’s hidden gems and headline acts, ensuring every acquisition is both personally meaningful and strategically sound.'
      },
    ],
    image: '/Member Services/Art Escrow & Consulting/body/3.png',
    imageAlt: 'Art Consulting Services'
  },
  masterpieceBackgroundImage: '/Member Services/Art Escrow & Consulting/CTA Banner/banner.png'
}

export default function ArtEscrowConsultingPage() {
  return (
    <>
      <Helmet>
        <title>Art Escrow & Consulting | Member Services | FGA Prestige</title>
        <meta name="description" content="Secure art transactions and expert consulting. Professional escrow services for fine art acquisitions, valuations, and secure transactions at FGA Prestige." />
        <link rel="canonical" href="https://fgaprestige.com/member-services/art-escrow-consulting" />
        <meta property="og:title" content="Art Escrow & Consulting | Member Services | FGA Prestige" />
        <meta property="og:description" content="Secure art transactions and expert consulting. Professional escrow services for fine art acquisitions, valuations, and secure transactions at FGA Prestige." />
        <meta property="og:url" content="https://fgaprestige.com/member-services/art-escrow-consulting" />
        <meta property="og:image" content="/Member Services/Art Escrow & Consulting/hero.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Art Escrow & Consulting Services" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Art Escrow & Consulting | Member Services | FGA Prestige" />
        <meta name="twitter:description" content="Secure art transactions and expert consulting. Professional escrow services for fine art acquisitions, valuations, and secure transactions at FGA Prestige." />
        <meta name="twitter:image" content="/Member Services/Art Escrow & Consulting/hero.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Art Escrow & Consulting",
            "description": "Secure art transactions and expert consulting. Professional escrow services for fine art acquisitions, valuations, and secure transactions at FGA Prestige.",
            "provider": {
              "@type": "Organization",
              "name": "FGA Prestige",
              "url": "https://fgaprestige.com"
            },
            "url": "https://fgaprestige.com/member-services/art-escrow-consulting",
            "image": "/Member Services/Art Escrow & Consulting/hero.png"
          })}
        </script>
      </Helmet>
      <ServicePageTemplate config={artEscrowConfig} />
    </>
  )
}